// Alerts and watchlists live in the user's AnalystBro desktop app (unified alerts, 2026-10-24):
// they are made by the agent (desktop chat or this site's chat) and evaluated on the desktop.
// This page shows the desktop's own Alerts pane through the relay, so it works while the
// desktop app is open with remote access on.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertsPane, DataClientProvider } from '../shared-ui';
import '../shared-ui/shared-ui.css';
import { relayDataClient } from '../components/hermes/relayDataClient';

export default function DesktopAlertsPage() {
  const navigate = useNavigate();
  return (
    <DataClientProvider client={relayDataClient}>
      <div className="desktop-alerts-page" style={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 820, display: 'flex' }}>
          <AlertsPane focus={null} onClose={() => navigate('/agentbro')} />
        </div>
      </div>
    </DataClientProvider>
  );
}
